import { Button, Paper, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import Iconify from '../../../../reusable-components/iconify';

ReportInvoiceDownloadedCard.propTypes = {
  back: PropTypes.func,
  backText: PropTypes.string,
};

export default function ReportInvoiceDownloadedCard({ back, backText }) {

  return <Paper sx={{ height: 'calc(100vh - 310px)', width: '100%', pt: 4, px: 4 }}>
    <Button
      variant="text"
      onClick={back}
      startIcon={<Iconify icon="mingcute:left-fill" width={24} height={24} sx={{ mx: -1 }} />}
      sx={{ color: '#454F5B', fontWeight: 'bold' }}
    >
      {backText}
    </Button>

    <Typography sx={{ pt: 10, textAlign: 'center' }} variant="h6" color="info.main">
      <Iconify icon="line-md:downloading-loop" color="info" width={48} height={48} sx={{ mx: -1 }} />
    </Typography>
    <Typography sx={{ pt: 2, textAlign: 'center' }} variant="h6" color="info.main">
      Your invoices have been downloaded.
    </Typography>
    <Typography sx={{ textAlign: 'center' }} variant="h6" color="info.main">
      Check your downloads folder.
    </Typography>
  </Paper>;
}